module.exports = __webpack_public_path__ + "static/rick-002-0832a6dc370d6a03663dbed8ba87a9a6.jpg";